<img src="./assets/images/{{image}}" alt="{{text}}">
<div class="contianer-button-to-mobile">
    <p-button (click)="routeTo()" class="eds-large" [ngClass]='{"small-text": applySmallText}' [label]="text">
    </p-button>
</div>